<template>
  <b-form-group
    :label="label"
    :label-for="id"
    class="bold-label mb-4"
    :state="price.state"
    :invalid-feedback="price.invalidFeedback">
    <div v-if="info">{{info}}</div>
    <div class="price-line">
      <b-input-group>
        <b-form-input
          :id="id"
          class="price-input"
          v-model="price.value"
          type="number"
          step="0.01"
          min="0"
          placeholder="0"
          :state="price.state"
          v-on:change="removeInvalidFeedback"
          :required="isRequired">
        </b-form-input>
        <b-input-group-append
          class="currency">
          {{currency}}
        </b-input-group-append>
      </b-input-group>
    </div>
    <b-form-text>{{helpMessage}}</b-form-text>
  </b-form-group>
</template>

<script>
export default {
  name: 'PriceField',

  props: {
    price: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: function () {
        return this.$t('Price')
      }
    },
    id: {
      type: String,
      default: 'price-input'
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    currency: {
      type: String,
      default: function () {
        return this.$t('defaultCurrency')
      }
    },
    info: {
      type: String,
      default: null
    },
    helpMessage: {
      type: String,
      default: null
    }
  },

  methods: {

    removeInvalidFeedback () {
      this.price.state = null
      this.price.invalidFeedback = null
    }

  }

}
</script>

<style scoped>

.price-line{
  display: flex;
  flex-direction: row;
}

.price-input {
  border-right: none;
}

.currency {
  border: 1px solid var(--main-border-color) !important;
  border-left: none;
  border-radius: 0 var(--small-border-radius) var(--small-border-radius) 0;
  padding-left: 1em;
  padding-right: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--background-grey) !important;
}

</style>



// WEBPACK FOOTER //
// src/components/b122/editFields/PriceField.vue